import { useContext, useEffect, useState } from "react";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import ReportContext from "../../context/500/ReportContext";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import { borderRadius } from "@mui/system";
import { CircularProgress } from "@mui/material";

function ReportDetail() {
  let [yearspecificData, setyearSpecificData] = useState([]);
  let { staffs } = useContext(CourseAssignmentContext);
  let { loading } = useContext(ReportContext);

  let {
    getCourseReport,
    ownassignmentcourses,
    setownassignmentcourses,
    otherDeptassignmentcourses,
    setotherDeptassignmentcourses,
    reqassignmentcourses,
    setreqassignmentcourses,
    admissionForReport,
    programForReport,
    showDetailsof,
    setshowDetailsof,
  } = useContext(ReportContext);

  useEffect(() => {
    arrangeData();
  }, []);

  useEffect(() => {
    arrangeData();
    console.log(showDetailsof);
  }, [showDetailsof]);

  useEffect(() => {
    getCourseReport(true);
  }, [staffs]);

  useEffect(() => {
    arrangeData();
  }, [
    admissionForReport,
    programForReport,
    ownassignmentcourses,
    otherDeptassignmentcourses,
    reqassignmentcourses,
    showDetailsof,
  ]);

  function arrangeData() {
    let data;

    let datatouse = [];

    if (showDetailsof == "own") {
      data = ownassignmentcourses;
    } else if (showDetailsof == "req") {
      data = reqassignmentcourses;
    } else if (showDetailsof == "other") {
      data = otherDeptassignmentcourses;
    }

    let yearnum = 1;
    for (let i = yearnum; i < 6; i++) {
      let total = 0;
      let courses = [];
      let year = i;

      if (data.unassignedCourses !== null) {
        // console.log("undefined",data.unassignedCourses[0])

        data.unassignedCourses?.forEach((course) => {
          if (course.year == i) {
            if (admissionForReport == "all" && programForReport == "all") {
              total = data.separateTotal.totalCourseNumberPerYear[i - 1];

              courses.push(course);
            } else {
              if (admissionForReport != "all" && programForReport != "all") {
                if (
                  course.course_admission == admissionForReport &&
                  ((course.course_program == "BSc" &&
                    programForReport == "BSc") ||
                    (course.course_program == "BA" &&
                      programForReport == "BSc"))
                ) {
                  courses.push(course);
                } else if (
                  course.course_admission == admissionForReport &&
                  course.course_program == programForReport
                ) {
                  courses.push(course);
                }

                if (
                  (admissionForReport == "Regular" &&
                    programForReport == "BSc") ||
                  (admissionForReport == "Regular" && programForReport == "BA")
                ) {
                  total =
                    data.combinationTotal.totalCourseNumberPerYearOfRegUg[
                      i - 1
                    ];
                } else if (
                  admissionForReport == "Regular" &&
                  programForReport == "Masters"
                ) {
                  total =
                    data.combinationTotal.totalCourseNumberPerYearOfRegMsc[
                      i - 1
                    ];
                } else if (
                  admissionForReport == "Regular" &&
                  programForReport == "Phd"
                ) {
                  total =
                    data.combinationTotal.totalCourseNumberPerYearOfRegPhd[
                      i - 1
                    ];
                } else if (
                  (admissionForReport == "Extension" &&
                    programForReport == "BSc") ||
                  (admissionForReport == "Extension" &&
                    programForReport == "BA")
                ) {
                  total =
                    data.combinationTotal.totalCourseNumberPerYearOfExtUg[
                      i - 1
                    ];
                } else if (
                  admissionForReport == "Extension" &&
                  programForReport == "Masters"
                ) {
                  total =
                    data.combinationTotal.totalCourseNumberPerYearOfExtMsc[
                      i - 1
                    ];
                } else if (
                  admissionForReport == "Extension" &&
                  programForReport == "Phd"
                ) {
                  total =
                    data.combinationTotal.totalCourseNumberPerYearOfExtPhd[
                      i - 1
                    ];
                }
              } else if (
                admissionForReport != "all" &&
                programForReport == "all"
              ) {
                if (course.course_admission == admissionForReport) {
                  courses.push(course);
                }

                if (admissionForReport == "Regular") {
                  total =
                    data.separateTotal.totalCourseNumberPerYearofRegular[i - 1];
                } else {
                  total =
                    data.separateTotal.totalCourseNumberPerYearofExtension[
                      i - 1
                    ];
                }
              } else if (
                admissionForReport == "all" &&
                programForReport != "all"
              ) {
                if (
                  (course.course_program == "BSc" &&
                    programForReport == "BSc") ||
                  (course.course_program == "BA" && programForReport == "BSc")
                ) {
                  courses.push(course);
                } else if (course.course_program == programForReport) {
                  courses.push(course);
                }
                if (programForReport == "BSc" || programForReport == "BA") {
                  total =
                    data.separateTotal.totalCourseNumberPerYearofug[i - 1];
                } else if (programForReport == "Phd") {
                  total =
                    data.separateTotal.totalCourseNumberPerYearofmsc[i - 1];
                } else {
                  total =
                    data.separateTotal.totalCourseNumberPerYearofphd[i - 1];
                }
              }
            }
          }
        });
      }
      let unassignedcoursesNumber = courses.length;

      let element = "";

      courses.forEach((c) => {
        element += `<span>${c.course_name}</span><br/>`;
      });

      if (courses.length > 0) {
        datatouse.push({
          year,
          courses,
          total,
          unassignedcoursesNumber,
          element,
        });
      }
    }

    setyearSpecificData(datatouse);
  }

  const theme = createTheme({
    zIndex: {
      tooltip: 3000,
    },
  });

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
      whiteSpace: "preWrap",
    },
  }));

  let [show, setshow] = useState(false);
  let [clicked, setclicked] = useState(false);

  if (yearspecificData.length > 0) {
    return (
      <div
        className="specific-container-details"
        style={{
          position: "absolute",
          zIndex: "2000",
          right: "25px",
          border: "2px solid lightgray",
          borderRadius: "5px",
        }}
      >
        <div className="specific-report-for-all-details">
          <div className="assignment-wrapper-details">
            {yearspecificData.map((data) => {
              return (
                <div className="assignment">
                  <div
                    style={{
                      width: "100%",
                      fontSize: "13px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ marginLeft: "15px" }}>Year {data.year}</span>
                    <span style={{ marginRight: "15px" }}>
                      {data.total == 0
                        ? "100%"
                        : Math.round(
                            ((data.total - data.unassignedcoursesNumber) *
                              100) /
                              data.total
                          ).toString() + "%"}
                    </span>
                  </div>
                  {data.element != "" ? (
                    <ThemeProvider theme={theme}>
                      <LightTooltip
                        title={
                          <div
                            className="tooltip-courses"
                            dangerouslySetInnerHTML={{ __html: data.element }}
                          ></div>
                        }
                        placement="top"
                        open={show == data.year ? true : false}
                      >
                        <div
                          style={{
                            width: "100%",
                            backgroundColor: "rgb(240, 240, 240)",
                            height: "12px",
                            borderRadius: "15px",
                          }}
                          onClick={() => {
                            setshow(!show);
                            setclicked(!clicked);
                          }}
                          onMouseOver={() => setshow(data.year)}
                          onMouseLeave={() => {
                            if (!clicked) setshow(0);
                          }}
                        >
                          <div
                            className="progress-bar-details"
                            style={{
                              width:
                                data.total == 0
                                  ? "100%"
                                  : Math.round(
                                      ((data.total -
                                        data.unassignedcoursesNumber) *
                                        100) /
                                        data.total
                                    ).toString() + "%",
                              height: "99%",
                              minWidth: "5%",
                              borderRadius: "15px",
                              backgroundColor: "darkblue",
                            }}
                          ></div>
                        </div>
                      </LightTooltip>
                    </ThemeProvider>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        backgroundColor: "rgb(240, 240, 240)",
                        height: "12px",
                        borderRadius: "15px",
                      }}
                      onClick={() => {
                        setshow(!show);
                        setclicked(!clicked);
                      }}
                      onMouseOver={() => setshow(data.year)}
                      onMouseLeave={() => {
                        if (!clicked) setshow(0);
                      }}
                    >
                      <div
                        className="progress-bar"
                        style={{
                          width:
                            data.total == 0
                              ? "100%"
                              : Math.round(
                                  ((data.total - data.unassignedcoursesNumber) *
                                    100) /
                                    data.total
                                ).toString() + "%",
                          height: "99%",
                          borderRadius: "15px",
                          backgroundColor: "darkblue",
                        }}
                      ></div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="specific-container-details"
        style={{
          position: "absolute",
          zIndex: "2000",
          right: "25px",
          border: "2px solid lightgray",
          borderRadius: "5px",
        }}
      >
        <div className="specific-report-for-all-details">
          <div className="assignment-wrapper-details">
            {loading == true && <CircularProgress />}

            {loading === false && <h4>All Assigned</h4>}
          </div>
        </div>
      </div>
    );
  }
}

export default ReportDetail;
